export type PlayheadEdge = 'start' | 'center' | 'end';

/**
 * Where to anchor an element drawn on the timeline playhead (its head, its
 * time label) so it stays inside the scroll container: centered on the
 * playhead, unless centering would push it past the start or end of the
 * track, where the scroll container clips it. At the start of a clip that
 * clipping (plus the line landing on the first scene's edge) made the
 * playhead look missing.
 */
export function resolvePlayheadEdge({
  positionPx,
  trackWidthPx,
  halfWidthPx,
}: {
  positionPx: number;
  trackWidthPx: number;
  halfWidthPx: number;
}): PlayheadEdge {
  if (positionPx < halfWidthPx) return 'start';
  if (trackWidthPx - positionPx < halfWidthPx) return 'end';
  return 'center';
}
